import SigliveServiceV1 from 'Service/sigliveServiceV1';

const getRequestApprovalType = async () => {
  const { data } = await SigliveServiceV1({ method: 'GET', url: '/request-approval/type-progress/list' });

  return data;
};

export default getRequestApprovalType;
